import React from "react";
import "./index.css";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import Footer from "./Components/Footer";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { AuthProvider } from "./utils/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
      <AuthProvider>
        <div className="app-shell flex flex-col bg-slate-950 text-xs text-white">
            <div className="flex min-h-0 flex-1 flex-col">
                <App />
            </div>
            <Footer />
        </div>
      </AuthProvider>
  </BrowserRouter>
);

serviceWorkerRegistration.register();
